import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { BsHouseDoor, BsGraphUp, BsFileText, BsBarChart } from 'react-icons/bs';
import './style.css';
import PageHeader from '../../components/PageHeader/PageHeader';

const Dashboard = () => {
  const donutBaseOptions = {
    chart: {
      type: 'pie',
      height: 300,
      backgroundColor: 'transparent',
      spacing: [20, 0, 20, 0],
      style: {
        fontFamily: 'Inter, sans-serif'
      },
      animation: {
        duration: 1000
      }
    },
    title: { text: null },
    plotOptions: {
      pie: {
        innerSize: '70%',
        borderWidth: 0,
        borderRadius: 8,
        size: '85%',
        center: ['50%', '45%'],
        dataLabels: {
          enabled: false
        },
        showInLegend: true,
        states: {
          hover: {
            brightness: 0.1,
            shadow: false
          }
        }
      }
    },
    legend: {
      enabled: true,
      align: 'right',
      verticalAlign: 'middle',
      layout: 'vertical',
      itemStyle: {
        color: 'var(--text)',
        fontWeight: '500',
        fontSize: '13px',
        textOverflow: 'ellipsis'
      },
      labelFormat: '{name}: {percentage:.1f}%',
      itemMarginTop: 8,
      symbolRadius: 6,
      itemDistance: 15,
      padding: 0,
      margin: 0,
      itemHoverStyle: {
        color: 'var(--primary)'
      },
      useHTML: true,
      symbolWidth: 12,
      symbolHeight: 12,
      itemHiddenStyle: {
        color: '#999999'
      }
    },
    tooltip: {
      headerFormat: '',
      pointFormat: '<div style="text-align: center"><span style="font-size: 13px; font-weight: 600; color: {point.color}">{point.name}</span><br/><b>{point.percentage:.1f}%</b></div>',
      backgroundColor: 'rgba(255, 255, 255, 0.98)',
      borderWidth: 0,
      borderRadius: 12,
      shadow: true,
      useHTML: true,
      style: {
        color: 'var(--text)',
        fontSize: '13px'
      },
      padding: 12
    },
    credits: { enabled: false }
  };

  const yayinIstatistikleriOptions = {
    ...donutBaseOptions,
    series: [{
      name: 'Toplam Makale',
      data: [
        { name: 'Q1', y: 850, color: '#4F46E5' },
        { name: 'Q2', y: 320, color: '#10B981' },
        { name: 'Diğer-WR', y: 280, color: '#F59E0B' }
      ]
    }]
  };

  const yayinMaliyetOptions = {
    ...donutBaseOptions,
    series: [{
      name: 'Toplam Makale (2019-2024)',
      data: [
        { name: 'Q1', y: 5200, color: '#4F46E5' },
        { name: 'Q2', y: 2100, color: '#10B981' },
        { name: 'Diğer-WR', y: 1500, color: '#F59E0B' }
      ]
    }]
  };

  const trendOptions = {
    chart: {
      type: 'spline',
      height: 350,
      backgroundColor: 'transparent',
      spacing: [20, 20, 20, 20],
      style: {
        fontFamily: 'Inter, sans-serif'
      },
      animation: {
        duration: 1000
      }
    },
    title: { text: null },
    xAxis: {
      categories: ['2019', '2020', '2021', '2022', '2023', '2024'],
      labels: { 
        style: { 
          color: 'var(--text-secondary)',
          fontSize: '13px',
          fontWeight: '500'
        } 
      },
      lineColor: 'var(--border)',
      gridLineColor: 'rgba(0, 0, 0, 0.05)',
      tickLength: 0,
      crosshair: {
        width: 1,
        color: 'rgba(79, 70, 229, 0.2)'
      }
    },
    yAxis: {
      title: { text: null },
      labels: { 
        style: { 
          color: 'var(--text-secondary)',
          fontSize: '13px',
          fontWeight: '500'
        } 
      },
      gridLineColor: 'rgba(0, 0, 0, 0.05)',
      crosshair: {
        width: 1,
        color: 'rgba(79, 70, 229, 0.2)'
      }
    },
    series: [
      {
        name: 'Q1',
        data: [620, 750, 830, 920, 1050, 850],
        color: {
          linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
          stops: [
            [0, '#4F46E5'],
            [1, '#818CF8']
          ]
        },
        marker: { 
          symbol: 'circle',
          radius: 6,
          lineWidth: 2,
          lineColor: '#4F46E5',
          fillColor: '#fff'
        },
        lineWidth: 3
      },
      {
        name: 'Q2',
        data: [180, 220, 250, 280, 310, 320],
        color: {
          linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
          stops: [
            [0, '#10B981'],
            [1, '#34D399']
          ]
        },
        marker: { 
          symbol: 'circle',
          radius: 6,
          lineWidth: 2,
          lineColor: '#10B981',
          fillColor: '#fff'
        },
        lineWidth: 3
      },
      {
        name: 'Diğer-WR',
        data: [150, 180, 210, 240, 260, 280],
        color: {
          linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
          stops: [
            [0, '#F59E0B'],
            [1, '#FBBF24']
          ]
        },
        marker: { 
          symbol: 'circle',
          radius: 6,
          lineWidth: 2,
          lineColor: '#F59E0B',
          fillColor: '#fff'
        },
        lineWidth: 3
      }
    ],
    legend: {
      itemStyle: { 
        color: 'var(--text)',
        fontSize: '13px',
        fontWeight: '500'
      },
      itemHoverStyle: { color: 'var(--primary)' },
      symbolRadius: 6,
      itemMarginTop: 8,
      itemDistance: 20,
      useHTML: true,
      symbolWidth: 12,
      symbolHeight: 12
    },
    plotOptions: {
      series: {
        states: {
          hover: {
            lineWidth: 4,
            halo: {
              size: 0
            }
          }
        },
        animation: {
          duration: 1000
        }
      }
    },
    tooltip: {
      backgroundColor: 'rgba(255, 255, 255, 0.98)',
      borderWidth: 0,
      borderRadius: 12,
      shadow: true,
      style: {
        color: 'var(--text)',
        fontSize: '13px'
      },
      padding: 12,
      headerFormat: '<span style="font-size: 13px; font-weight: 600">{point.key}</span><br/>',
      pointFormat: '<span style="color: {series.color}">{series.name}</span>: <b>{point.y}</b>'
    },
    credits: { enabled: false }
  };

  const yazarSayisiOptions = {
    ...donutBaseOptions,
    series: [{
      name: 'Toplam Yürüyen Proje Sayısı',
      data: [
        { name: 'TÜBİTAK', y: 450, color: '#4F46E5' },
        { name: 'BAP', y: 280, color: '#10B981' },
        { name: '1773TTO', y: 120, color: '#F59E0B' },
        { name: 'TTG', y: 180, color: '#EF4444' },
        { name: 'TÜBİTAK', y: 90, color: '#8B5CF6' },
        { name: 'Diğer Sermaye', y: 75, color: '#EC4899' },
        { name: 'AB', y: 85, color: '#14B8A6' }
      ]
    }]
  };

  const projeDagilimOptions = {
    ...donutBaseOptions,
    series: [{
      name: 'Toplam Yürüyen Bütçe Miktarı',
      data: [
        { name: 'TÜBİTAK', y: 850, color: '#4F46E5' },
        { name: 'BAP', y: 420, color: '#10B981' },
        { name: '1773TTO', y: 180, color: '#F59E0B' },
        { name: 'TTG', y: 320, color: '#EF4444' },
        { name: 'TÜBİTAK', y: 150, color: '#8B5CF6' },
        { name: 'Diğer Sermaye', y: 130, color: '#EC4899' },
        { name: 'AB', y: 160, color: '#14B8A6' }
      ]
    }]
  };

  const butceDagilimOptions = {
    ...donutBaseOptions,
    series: [{
      name: 'Toplam Proje Sayısı',
      data: [
        { name: 'TÜBİTAK', y: 1250, color: '#4F46E5' },
        { name: 'BAP', y: 680, color: '#10B981' },
        { name: '1773TTO', y: 320, color: '#F59E0B' },
        { name: 'TTG', y: 480, color: '#EF4444' },
        { name: 'BOREN', y: 180, color: '#8B5CF6' },
        { name: 'TÜBİTAK', y: 220, color: '#EC4899' },
        { name: 'UDAP', y: 150, color: '#14B8A6' }
      ]
    }]
  };

  return (
    <div className="dashboard">
      <PageHeader 
        title="Genel Bakış"
        description="Akademik performans göstergeleri ve istatistikler"
        breadcrumbs={[
          { text: 'Ana Sayfa', href: '/' },
          { text: 'Genel Bakış' }
        ]}
      />

      <div className="container-fluid p-0">
        <div className="row g-4">
          <div className="col-md-6">
            <div className="dashboard-card">
              <div className="card-header">
                <h3><BsFileText /> Toplam Makale</h3>
                <span className="badge">2024</span>
              </div>
              <HighchartsReact highcharts={Highcharts} options={yayinIstatistikleriOptions} />
            </div>
          </div>

          <div className="col-md-6">
            <div className="dashboard-card">
              <div className="card-header">
                <h3><BsFileText /> Toplam Yürüyen Proje Sayısı</h3>
                <span className="badge">2024</span>
              </div>
              <HighchartsReact highcharts={Highcharts} options={yazarSayisiOptions} />
            </div>
          </div>

          <div className="col-md-6">
            <div className="dashboard-card">
              <div className="card-header">
                <h3><BsGraphUp /> Makale</h3>
                <span className="badge">2019-2024</span>
              </div>
              <HighchartsReact highcharts={Highcharts} options={trendOptions} />
            </div>
          </div>

          <div className="col-md-6">
            <div className="dashboard-card">
              <div className="card-header">
                <h3><BsFileText /> Toplam Makale</h3>
                <span className="badge">2019-2024</span>
              </div>
              <HighchartsReact highcharts={Highcharts} options={yayinMaliyetOptions} />
            </div>
          </div>

          <div className="col-md-6">
            <div className="dashboard-card">
              <div className="card-header">
                <h3><BsFileText /> Toplam Yürüyen Bütçe Miktarı</h3>
                <span className="badge">2024</span>
              </div>
              <HighchartsReact highcharts={Highcharts} options={projeDagilimOptions} />
            </div>
          </div>

          <div className="col-md-6">
            <div className="dashboard-card">
              <div className="card-header">
                <h3><BsFileText /> Toplam Proje Sayısı</h3>
                <span className="badge">2019-2024</span>
              </div>
              <HighchartsReact highcharts={Highcharts} options={butceDagilimOptions} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard; 